import { TEditableEntity, TTeaserEntity } from '../types';

export const teaserToEditableEntity = (
  teaser: TTeaserEntity
): TEditableEntity => {
  const { logoImageUrl, ...other } = teaser;

  return { ...other, logoUrl: logoImageUrl };
};
